/**
 * web-vitals-init.js
 * Real-User Monitoring (RUM): reports Core Web Vitals to the GTM dataLayer.
 *
 * Reads the field-measured values from the self-hosted google/web-vitals
 * library (loaded just before this) and pushes one `web_vitals` dataLayer
 * event per metric. Passive measurement only — observes page lifecycle and
 * reports on page hide; it changes nothing the user sees.
 *
 * To surface the data: in GTM add a GA4 Event tag (event name `web_vitals`)
 * triggered on the Custom Event `web_vitals`, mapping these dataLayer keys to
 * event parameters: web_vitals_metric, web_vitals_value, web_vitals_rating,
 * web_vitals_id, web_vitals_navigation_type, web_vitals_page_path.
 */
(function () {
  'use strict';
  if (!window.webVitals) return;

  window.dataLayer = window.dataLayer || [];

  function report(metric) {
    // CLS is unitless; send x1000 as an integer so GA4 aggregates cleanly.
    var value = metric.name === 'CLS'
      ? Math.round(metric.value * 1000)
      : Math.round(metric.value);

    window.dataLayer.push({
      event: 'web_vitals',
      web_vitals_metric: metric.name,            // LCP | INP | CLS | FCP | TTFB
      web_vitals_value: value,
      web_vitals_rating: metric.rating,          // good | needs-improvement | poor
      web_vitals_id: metric.id,
      web_vitals_navigation_type: metric.navigationType,
      web_vitals_page_path: location.pathname,
    });
  }

  webVitals.onLCP(report);
  webVitals.onINP(report);
  webVitals.onCLS(report);
  webVitals.onFCP(report);
  webVitals.onTTFB(report);
})();
